const styles = () => ({
  mainContainer: {
    margin: '30px 0'
  }
});

export default styles;
